<template>
  <div class="product-details-component">
    <div class="container px-4">
      <div class="row">
        <div class="col-12">
          <div class="product-name">
            {{ productDetails.name }}
          </div>
          <div class="underlined">Sizes</div>
          <div class="specs">
            {{ productDetails.sizes }}
          </div>
          <div class="mt-3"></div>
          <div class="underlined">Price starts at</div>
          <div class="specs">
            Php {{ productDetails.price }}
          </div>
          <div class="mt-5"></div>
          <a :href="productDetails.lazada_url" target="_blank" class="btn btn-lg btn-block btn-dutche-orange">
            <strong>Shop from lazada</strong>
          </a>
          <div class="mt-2"></div>
          <a :href="productDetails.shopee_url" target="_blank" class="btn btn-lg btn-block btn-dutche-orange">
            <strong>Shop from shopee</strong>
          </a>
          <div class="mt-5"></div>
          <div class="underlined">Description</div>
          <div class="specs">
            {{ productDetails.description }}
          </div>
          <div class="mb-5"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Details',
  props: {
    productDetails: Object
  }
}
</script>

<style lang="sass" scoped>
.product-details-component
  background: $dutche-senary-violet
  padding: 1.75rem 0
.product-details-component
  .product-name
    font-family: 'Might Could'
    font-size: 2em
    text-transform: uppercase

  .underlined
    text-transform: uppercase
    color: $dutche-primary-yellow
    border-bottom: 1px solid $dutche-primary-violet
    font-size: 0.9em
    font-weight: bold
  
  .specs
    font-size: 1.2em

  .btn-dutche-orange
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-orange
    color: $white
</style>
